<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="blue"
          title="Data Pelamar"
          text="Data pelamar yang sudah melakukan DISC Test"
        >
          <v-card-title>
            <v-toolbar flat color="white">
              <v-spacer />
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Cari Pelamar..."
                single-line
                hide-details
              />
            </v-toolbar>
          </v-card-title>

          <v-flex md12>
            <v-data-table
              :headers="headers"
              :items="applicants"
              :search="search"
              class="elevation-3"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              sort-icon="mdi-menu-down"
            >
              <template slot="headerCell" slot-scope="{header}">
                <span
                  slot="activator"
                  class="subheading text-info text--darken-3"
                  v-text="header.text"
                />
              </template>
              <!-- <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear> -->
              <template slot="items" slot-scope="{item}">
                <td class="font-weight-regular">{{ item.id_number }}</td>
                <td class="font-weight-regular">{{ item.name }}</td>
                <td class="font-weight-regular">{{ item.gender }}</td>
                <td class="font-weight-regular">{{ item.birthday_date | dateFormat }}</td>
                <td class="justify-right">
                  <v-flex xs8 sm8 class="px-0">
                    <v-btn
                      v-tooltip.top-center="{content: 'tampilkan hasil test'}"
                      slot="activator"
                      :disabled="item.result === null"
                      :to="'/detail/'+item.id"
                      small
                      color="indigo accent-3"
                    >
                      Hasil test
                    </v-btn>
                  </v-flex>
                </td>
              </template>

              <template slot="no-data">
                <v-progress-circular :size="50" :width="3" color="blue" indeterminate />
              </template>

              <v-alert
                slot="no-results"
                :value="true"
                color="red"
                icon="warning"
              >Pencarian "{{ search }}" tidak ditemukan</v-alert>
            </v-data-table>
          </v-flex>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
export default {
  filters: {
    dateFormat(date) {
      let newDate = new Date(date);

      let dd = newDate.getDate();
      let mm = newDate.getMonth() + 1;
      let yyyy = newDate.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      let newFormat = dd + "-" + mm + "-" + yyyy;

      return newFormat;
    }
  },
  data() {
    return {
      headers: [
        {
          // sortable: false,
          text: "No. KTP",
          value: "id_number"
        },
        {
          // sortable: false,
          text: "Nama",
          value: "name"
        },
        {
          // sortable: false,
          text: "Jenis Kelamin",
          value: "gender"
        },
        {
          // sortable: false,
          text: "Tanggal Lahir",
          value: "birthday_date"
        },
        {
          //   sortable: false,
          text: "Action",
          value: "-"
        }
      ],

      applicants: [],
      dialog: false,
      search: ""
    };
  },

  async mounted() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    // pake created juga bisa
    try {
      const response = await this.axios.get("/applicants");
      this.applicants = response.data.data;
    } catch (e) {
      console.log(e.response);
    }
  },

  methods: {
    showDetail() {
      this.$router.push("/detail");
    }
  }
};
</script>
